import * as qs from 'qs';
import api, { armorAPI } from '~/services/api';

const baseURL = CONFIG.apiBaseUrl;
const transactionLimit = '1000';

function getTransactions(
  carrier: unknown,
  startDate: string,
  endDate: string,
  limit = transactionLimit,
) {
  const params = {
    filter: {
      carrier,
      start_date: startDate,
      end_date: endDate,
      status: 'success',
    },
    expand: ['rate', 'parcel'],
    page: {
      limit,
      number: '1',
    },
  };
  return api.request({
    baseURL,
    params,
    url: 'transactions/pickups/search',
    method: 'GET',
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'brackets' });
    },
  });
}

function getCarrierAccounts(carrier: string) {
  return api.request({
    baseURL,
    url: 'carrier_accounts',
    params: {
      carrier,
    },
    method: 'GET',
  });
}

function getCarrierBuildingLocationTypes(carrierId: string) {
  return api.request({
    baseURL,
    url: `transactions/pickups/building_location_types/${carrierId}`,
    params: {},
    method: 'GET',
  });
}

function sendPickupsRequest(payload) {
  return armorAPI.request({
    url: 'pickups/',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: payload,
  });
}

export { getTransactions, getCarrierAccounts, sendPickupsRequest, getCarrierBuildingLocationTypes };
